import React from 'react';
import styled from 'styled-components';
import { Popup } from "semantic-ui-react";
import Text from 'new_components/atoms/Text';
import colors from 'styles/colors';
import typography from 'styles/typography';

const MIN_WIDTH_PERCENT = 5;

const QuestionDistributionChart = ({ data, legend }) => {
    if (!data || data.length === 0) {
        return null;
    }

    const percentages = data.map(item => item.data[0]);

    const adjustedPercentages = adjustSmallBars(percentages);

    return (
        <OuterContainer>
            <TitleRow>
                {/* <Text typographyStyle={typography.subhead.semibold} color={colors.text.dark}>
                    Overall Response Distribution
                </Text> */}
                {legend}
            </TitleRow>
            <ChartContainer>
                <BarContainer>
                    {data.map((item, index) => {

                        return (
                            <Popup
                                content={`${item.count} responses`}
                                position="top center"
                                inverted
                                trigger={
                                    <BarSection
                                        key={index}
                                        width={adjustedPercentages[index]}
                                    >
                                        <Bar color={item.color}>
                                            <Text typographyStyle={typography.caption.semibold} color={"white"}>
                                                {Math.round(item.data[0])}%
                                            </Text>
                                        </Bar>
                                    </BarSection>
                                }
                            />
                        )
                    })}
                </BarContainer>
            </ChartContainer>
        </OuterContainer>
    );
};

const adjustSmallBars = (percentages) => {
    const smallBars = percentages.map((p) =>
        p < MIN_WIDTH_PERCENT ? MIN_WIDTH_PERCENT : p
    );
    const totalSmallBarWidth = smallBars.reduce(
        (sum, p, i) =>
            sum + (percentages[i] < MIN_WIDTH_PERCENT ? MIN_WIDTH_PERCENT : 0),
        0
    );
    const totalOriginalSmallBarWidth = percentages.reduce(
        (sum, p) => sum + (p < MIN_WIDTH_PERCENT ? p : 0),
        0
    );

    const adjustment = totalOriginalSmallBarWidth - totalSmallBarWidth;
    const largeBars = percentages.map((p) => (p >= MIN_WIDTH_PERCENT ? p : 0));
    const totalLargeBarWidth = largeBars.reduce((sum, p) => sum + p, 0);

    return percentages.map((p) => {
        if (p >= MIN_WIDTH_PERCENT) {
            const newPercentage =
                (p / totalLargeBarWidth) * (totalLargeBarWidth + adjustment);
            return newPercentage;
        }
        return MIN_WIDTH_PERCENT;
    });
};

const OuterContainer = styled.div`
    width: 100%;
`;

const ChartContainer = styled.div`
    position: relative;
    background-color: #f9fafb;
    padding: 10px;
    border-radius: 8px;
    width: 100%;
    margin: 0 auto;
`;

const BarContainer = styled.div`
    display: flex;
    height: 40px;
    border-radius: 8px;
    gap: 2px;
    justify-content: space-between;
`;

const BarSection = styled.div`
    width: ${props => props.width}%;
    transition: width 0.3s ease;
`;

const Bar = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.color};
    display: flex;
    align-items: center;
    color: white;
    font-weight: bold;
    border-radius: 4px;
    padding-left: 10px;
`;

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
`;

export default QuestionDistributionChart; 